"use client";
import { Elements } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../components/CheckoutForm";
import { useSelector } from "react-redux";
import { getpaymentmethods } from "../collection/ApiCollection";
import { useNavigate } from "react-router-dom";

const Payment = () => {
    const navigate = useNavigate()
    const [clientSecret, setClientSecret] = useState("");
    const [cardListing, setCardListing] = useState(null)
    const handleGetAllCard = async () => {
        try {
            let res = await getpaymentmethods();
            if (res.status === 200) {
                setCardListing(res?.data?.data)
            } else {
                setCardListing(null)
            }
        } catch (error) {
            setCardListing(null)
        }
    }

    useEffect(() => {
        handleGetAllCard()
    }, [])
    const stripePromise = loadStripe(
        "pk_test_51QKnOZK0DzdlOO6IoRy2ZXy6Wnl17P9LRM2p177Grh6BApETVMef2kgthqfGJTXD8xOfROUMmySTtvV34GlDdxcP00ccf2R2Wi"
    );
    useEffect(() => {
        setClientSecret("client_secret");
    }, []);

    useEffect(() => {
        if (cardListing?.[0]?.isDefault) {
            navigate("/landing/schedule")
        }
    }, [cardListing])

    return (
        <div>
            <Elements stripe={stripePromise}>
                {clientSecret && <CheckoutForm />}
            </Elements>
        </div>
    );
};

export { Payment };